import { useEffect, useRef } from 'react'
import clsx from 'clsx'
import type { FolderSelectionState } from './useRecursiveFolderSelection'

type FolderSelectionCheckboxProps = {
  disabled: boolean
  folderName: string
  onToggle: () => void
  state: FolderSelectionState
}

export function FolderSelectionCheckbox({ disabled, folderName, onToggle, state }: FolderSelectionCheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const isPartial = state === 'partial-selected'
  const isChecked = state === 'checked'

  useEffect(() => {
    if (!inputRef.current) return
    inputRef.current.indeterminate = isPartial
  }, [isPartial])

  return (
    <input
      ref={inputRef}
      type="checkbox"
      checked={isChecked}
      disabled={disabled}
      onClick={(event) => event.stopPropagation()}
      onChange={onToggle}
      aria-label={`Select ${folderName}`}
      className={clsx(
        'shrink-0 border-brand-neutral-300 text-brand-500 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-inset h-4 w-4 rounded',
        disabled ? 'cursor-not-allowed disabled:bg-brand-neutral-100' : 'cursor-pointer'
      )}
    />
  )
}
